/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */
var isElement = function (o) {
    return o instanceof Element || o instanceof Document;
};
export default isElement;
//# sourceMappingURL=is-element.js.map